import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, imageUrl } from "@/lib/api";
import { useShop } from "@/context/ShopContext";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import Marquee from "@/components/site/Marquee";

const DEFAULT_STORY =
  "Kubwalo Fragrances was created for those who understand that fragrance is more than what you wear. It's how you express yourself, how you make an entrance, and how people remember you. Our goal is to make discovering your next signature scent an experience worth remembering.";

export default function About() {
  const { settings } = useShop();

  return (
    <div className="pt-20" data-testid="about-page">
      <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden grain">
        <div className="absolute inset-0">
          {settings?.about_image_url && (
            <img
              src={imageUrl(settings.about_image_url)}
              alt="Kubwalo fragrance bottle"
              className="w-full h-full object-cover"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-[#080808] via-[#080808]/70 to-[#080808]/80" />
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <p className="eyebrow mb-8">Our Story</p>
          <h1 className="font-serif-display font-light text-white leading-[1.06] text-4xl sm:text-5xl lg:text-7xl" data-testid="about-headline">
            <MaskedLines lines={["YOUR SCENT.", "YOUR STORY.", "YOUR LEGACY."]} />
          </h1>
        </div>
      </section>

      <Marquee />

      <section className="max-w-3xl mx-auto px-6 py-24 sm:py-32 text-center">
        <Reveal>
          <p className="eyebrow mb-6">The House</p>
          <p className="font-serif-display text-2xl sm:text-3xl text-white font-light leading-relaxed" data-testid="about-story">
            {settings?.about_story || DEFAULT_STORY}
          </p>
          <div className="w-16 h-px bg-[#D4AF37]/50 mx-auto mt-12" />
        </Reveal>
        <Reveal delay={0.15}>
          <p className="font-sans-body text-base text-[#B8B8B8] font-light leading-relaxed mt-12">
            Every Kubwalo fragrance is an independent creation — made for the moments that matter,
            the rooms you want to be remembered in, and the confidence that arrives before you do.
            This is fragrance as identity: personal, intentional, and unmistakably yours.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <Link to="/shop" className="btn-gold mt-12 inline-flex" data-testid="about-shop-button">
            Explore the Collection <ArrowRight size={14} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
